import { Stack, styled, Typography } from '@mui/material'

export const StyledBaseContainer = styled(Stack)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderRadius: '16px',
  boxShadow: theme.shadows[12],
  padding: '24px',
}))

export const StyledTextValue = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  wordBreak: 'normal',
  overflowWrap: 'break-word',
}))
